import { IList } from 'annotation-tools/utils';
import { FetchErrorType } from '../../types/common/fetch-error-type';
import { FetchResultType } from '../../types/common/fetch-result';
import { defaultErrorResponseConverter } from './base/fetch/error-response-converter-generator';
import { fetchJsonWithTokenCheck } from './base/fetch/fetch-json-with-token-check';
import { mapFetchResult } from './base/fetch/map-fetch-result';
import {
  RawDetailErrorType,
  RawNonFieldErrorsType
} from './base/fetch/types/common-error-type';

export const fetchListTemplateFn = async <
  RawSuccessResponseElementType extends object,
  SuccessResponseElementType
>(
  token: string,
  uri: string,
  successResponseElementConverter: (
    v: RawSuccessResponseElementType
  ) => SuccessResponseElementType
): Promise<FetchResultType<
  IList<SuccessResponseElementType>,
  FetchErrorType<void>
>> => {
  const result = await fetchJsonWithTokenCheck({ token, uri, method: 'GET' });

  return mapFetchResult(
    result as FetchResultType<
      RawSuccessResponseElementType[],
      RawDetailErrorType | RawNonFieldErrorsType
    >,
    array =>
      IList<SuccessResponseElementType>(
        array.map(successResponseElementConverter)
      ),
    defaultErrorResponseConverter
  );
};
